export const ProductionItemsInfoColumns = () => {
  function shortenListWithDots(input) {
    const parts = input.split(",").map((s) => s.trim());
    if (parts.length <= 2) return input; // No need to shorten if 2 or fewer items
    return `${parts.slice(0, 2).join(", ")}, ...`;
  }
  return [
    {
      title: "MAC",
      dataIndex: "Mac",
      key: "Mac",
      //   sorter: (a, b) => () => {},
      //   sortIcon: () => (
      //     <SortIcon
      //       sortOrder={modParams.order}
      //       columnKey="ProductionNo"
      //       sortBy={modParams.sort_by}
      //     />
      //   ),
      //   onHeaderCell: () => ({
      //     onClick: () =>
      //       setParams((prev) => ({
      //         ...modParams,
      //         sort_by: "ProductionNo",
      //         order: modParams.order === "desc" ? "asc" : "desc",
      //       })),
      //   }),
    },
    {
      title: "Oem",
      dataIndex: "Oem",
      key: "Oem",
      //   sorter: (a, b) => () => {},
      //   sortIcon: () => (
      //     <SortIcon
      //       sortOrder={modParams.order}
      //       columnKey="ProductionNo"
      //       sortBy={modParams.sort_by}
      //     />
      //   ),
      //   onHeaderCell: () => ({
      //     onClick: () =>
      //       setParams((prev) => ({
      //         ...modParams,
      //         sort_by: "ProductionNo",
      //         order: modParams.order === "desc" ? "asc" : "desc",
      //       })),
      //   }),
    },
    {
      title: "Product",
      dataIndex: "Product",
      key: "Product",

      //   sorter: (a, b) => () => {},
      //   sortIcon: () => (
      //     <SortIcon
      //       sortOrder={modParams.order}
      //       columnKey="ProductionName"
      //       sortBy={modParams.sort_by}
      //     />
      //   ),
      //   onHeaderCell: () => ({
      //     onClick: () =>
      //       setParams((prev) => ({
      //         ...modParams,
      //         sort_by: "ProductionName",
      //         order: modParams.order === "desc" ? "asc" : "desc",
      //       })),
      //   }),
    },
    {
      title: "Site Type",
      dataIndex: "SiteType",
      key: "SiteType",

      //   sorter: (a, b) => () => {},
      //   sortIcon: () => (
      //     <SortIcon
      //       sortOrder={modParams.order}
      //       columnKey="ProductionName"
      //       sortBy={modParams.sort_by}
      //     />
      //   ),
      //   onHeaderCell: () => ({
      //     onClick: () =>
      //       setParams((prev) => ({
      //         ...modParams,
      //         sort_by: "ProductionName",
      //         order: modParams.order === "desc" ? "asc" : "desc",
      //       })),
      //   }),
    },
    {
      title: "Model",
      dataIndex: "Model",
      key: "Model",

      //   sorter: (a, b) => () => {},
      //   sortIcon: () => (
      //     <SortIcon
      //       sortOrder={modParams.order}
      //       columnKey="ProductionName"
      //       sortBy={modParams.sort_by}
      //     />
      //   ),
      //   onHeaderCell: () => ({
      //     onClick: () =>
      //       setParams((prev) => ({
      //         ...modParams,
      //         sort_by: "ProductionName",
      //         order: modParams.order === "desc" ? "asc" : "desc",
      //       })),
      //   }),
    },
    {
      title: "Door",
      dataIndex: "Type",
      key: "Type",

      //   sorter: (a, b) => () => {},
      //   sortIcon: () => (
      //     <SortIcon
      //       sortOrder={modParams.order}
      //       columnKey="ProductionDesc"
      //       sortBy={modParams.sort_by}
      //     />
      //   ),
      //   onHeaderCell: () => ({
      //     onClick: () =>
      //       setParams((prev) => ({
      //         ...modParams,
      //         sort_by: "ProductionDesc",
      //         order: modParams.order === "desc" ? "asc" : "desc",
      //       })),
      //   }),
    },
    {
      title: "License Options",
      dataIndex: "Options",
      key: "Options",
      render: (text) => {
        return text?.length > 0 ? shortenListWithDots(text) : "";
      },
      //   sorter: (a, b) => () => {},
      //   sortIcon: () => (
      //     <SortIcon
      //       sortOrder={modParams.order}
      //       columnKey="ProductionTime"
      //       sortBy={modParams.sort_by}
      //     />
      //   ),
      //   onHeaderCell: () => ({
      //     onClick: () =>
      //       setParams((prev) => ({
      //         ...modParams,
      //         sort_by: "ProductionTime",
      //         order: modParams.order === "desc" ? "asc" : "desc",
      //       })),
      //   }),
    },
    {
      title: "License Devices",
      dataIndex: "Devices",
      key: "Devices",
      render: (text) => {
        return text?.length > 0 ? shortenListWithDots(text) : "";
      },
      //   sorter: (a, b) => () => {},
      //   sortIcon: () => (
      //     <SortIcon
      //       sortOrder={modParams.order}
      //       columnKey="OemNo"
      //       sortBy={modParams.sort_by}
      //     />
      //   ),
      //   onHeaderCell: () => ({
      //     onClick: () =>
      //       setParams((prev) => ({
      //         ...modParams,
      //         sort_by: "OemNo",
      //         order: modParams.order === "desc" ? "asc" : "desc",
      //       })),
      //   }),
    },
    {
      title: "",
      fixed: "right",
      width: 0,
      align: "center",
      // render: (text, record, rowIndex) =>
      //   hoveredRow === rowIndex ? (
      //     <div className="absolute top-2 right-5">
      //       <div className="bg-[#EFF0F2] duration-75 bottom-0 flex gap-2 items-center justify-center z-50">
      //         {/* <Tooltip title="Edit">
      //           <div className="hover:bg-gray-400 px-[5px] py-[5px] rounded-[4px] mr-1 ">
      //             <Link
      //               to={`/production/edit/${record?.ProductionNo}`}
      //               onClick={(e) => e.stopPropagation()}
      //               className=" hover:text-[#636262ee]"
      //             >
      //               <EditOutlined />
      //             </Link>
      //           </div>
      //         </Tooltip> */}
      //         <Tooltip title="Delete">
      //           <div
      //             onClick={(e) => {
      //               e.stopPropagation();
      //               setShowModal(true);
      //               setSelectedRowKeys([record?.ProductionItemNo]);
      //             }}
      //             className="cursor-pointer hover:bg-gray-400 px-[5px] py-[5px] rounded-[4px] "
      //           >
      //             <DeleteOutlined />
      //           </div>
      //         </Tooltip>
      //       </div>
      //     </div>
      //   ) : null,
    },
  ];
};
